import { useAuth0 } from '@auth0/auth0-react';

export const useApiAuth = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const getAuthHeaders = async (): Promise<Record<string, string>> => {
    if (!isAuthenticated) {
      return {};
    }

    try {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        }
      });
      
      return {
        Authorization: `Bearer ${token}`,
      };
    } catch (error) {
      console.error('Error getting access token:', error);
      return {};
    }
  };

  const makeAuthenticatedRequest = async (url: string, options: RequestInit = {}) => {
    const authHeaders = await getAuthHeaders();
    
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...authHeaders,
    };

    // Add any existing headers from options
    if (options.headers) {
      const existingHeaders = options.headers as Record<string, string>;
      Object.assign(headers, existingHeaders);
    }
    
    return fetch(url, {
      ...options,
      headers,
    });
  };

  return {
    getAuthHeaders,
    makeAuthenticatedRequest,
    isAuthenticated,
  };
};